import { BaseWidgetProps } from 'consumer-page-widgets/WidgetUtils/BaseWidgetProps';
import { StoreType } from '@tock/shared/utils/connect';
import { WidgetCreatorContentProps } from 'components/www/WidgetCreatorContent';
import { consumer, core } from '@tock/coretypes';
import { currentMetroAreaSelector } from 'selectors/metroAreaSelectors';
import { getDisplayComponentForWidget } from 'utils/widgetUtils';
import { metroAreaContainerWidgetContainer } from 'consumer-page-widgets/MetroAreaContainerWidget/metroAreaContainerWidgetCssDefs';
import { useSelector } from 'react-redux';
import React from 'react';
import WidgetLayoutContainer from 'consumer-page-widgets/WidgetUtils/WidgetLayoutContainer';

interface ConnectProps {
  currentMetroArea: core.MetroArea | undefined;
}

interface MetroAreaContainerWidgetProps extends BaseWidgetProps {
  widget: consumer.IMetroAreaContainerWidget;
  widgetInfo?: consumer.IWidgetInfo;
  options: WidgetCreatorContentProps['options'];
  pageWidgetListIndex?: number;
}

const MetroAreaContainerWidget: React.FunctionComponent<MetroAreaContainerWidgetProps> = ({
  widget,
  widgetInfo,
  options,
  pageWidgetListIndex,
}) => {
  const { currentMetroArea } = useSelector(mapStateToProps);

  const getDisplayContentForPatronMetro = (
    metroWidgets: consumer.IMetroAreaWidgetItem[],
    defaultWidget?: consumer.IMetroAreaWidgetItem
  ) => {
    const widgetForMetro =
      metroWidgets.find((metroWidget) =>
        metroWidget.metro?.find((ma) => ma.id === currentMetroArea?.id)
      ) ??
      (defaultWidget || {});

    return getDisplayComponentForWidget(
      { ...widgetForMetro, widgetInfo },
      {},
      pageWidgetListIndex || 0,
      options
    );
  };

  return (
    <WidgetLayoutContainer>
      <div css={metroAreaContainerWidgetContainer}>
        {getDisplayContentForPatronMetro(widget.metroWidgets || [], widget)}
      </div>
    </WidgetLayoutContainer>
  );
};

function mapStateToProps(state: StoreType): ConnectProps {
  return {
    currentMetroArea: currentMetroAreaSelector(state),
  };
}

export default MetroAreaContainerWidget;
